(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reducedMotion || !('IntersectionObserver' in window)) {
    document.documentElement.classList.add('vzyra-reveal-ready');
    document.querySelectorAll('[data-vzyra-reveal]').forEach((element) => {
      element.classList.add('is-visible');
    });
    return;
  }

  document.documentElement.classList.add('vzyra-reveal-ready');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
  );

  document.querySelectorAll('[data-vzyra-reveal]').forEach((element) => observer.observe(element));
})();
